/* eslint-disable quotes */ 

const base = {
  h: '50px',
  fontSize: '16px',
  px: '30px',
  borderRadius: '25px'
};

const focusVisibleStyles = {
  _focusVisible: {
    outline: '2px solid #0b0c0c',
    outlineOffset: '2px'
  }
};

const whiteFocusVisibleStyles = {
  _focusVisible: {
    outline: '2px solid #fff',
    outlineOffset: '-3px'
  }
};

export const mleTheme = ({
  fonts: {
    heading: `'Muli', sans-serif`,
    body: `'Muli', sans-serif`
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        color: 'white',
        ...focusVisibleStyles
      },
      variants: {
        'header-btn': {
          _focusVisible: {
            ...focusVisibleStyles._focusVisible,
            outlineOffset: '-3px'
          }
        },
        mle: {
          ...base,
          ...whiteFocusVisibleStyles,
          bg: '#3477c7',
          _hover: {
            bg: '#fd7849',
            _disabled: {
              bg: '#3477c7'
            }
          }
        },
        mleInvert: {
          ...base,
          ...whiteFocusVisibleStyles,
          bg: '#fd7849',
          _hover: {
            bg: '#3477c7',
            _disabled: {
              bg: '#fd7849'
            }
          }
        }
      }
    }
  }
});
